/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IFlujosEtapasCompuesta from 'Infotrack@Modelos/smartStock/flujosEtapas/entidades/flujosEtapasCompuesta';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IFlujosEtapasCompuesta>> => [
    {
        title: formatMessage({ id: 'flujosEtapas.flujoDescripcion' }),
        field: 'FlujoDescripcion',
    },
    {
        title: formatMessage({ id: 'flujosEtapas.etapaDescripcionActual' }),
        field: 'DescripcionEtapaActual',
    },
    {
        title: formatMessage({ id: 'flujosEtapas.etapaDescripcionSiguiente' }),
        field: 'DescripcionEtapaSiguiente',
    },
    {
        title: formatMessage({ id: 'flujosEtapas.entrada' }),
        field: 'Entrada',
        type: 'boolean',
    },
    {
        title: formatMessage({ id: 'flujosEtapas.salida' }),
        field: 'Salida',
        type: 'boolean',
    },
    {
        title: formatMessage({ id: 'flujosEtapas.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, flujosEtapas?: IFlujosEtapasCompuesta) => void,
    cargarFlujosEtapas: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (flujosEtapas: IFlujosEtapasCompuesta) => void
): Array<Action<IFlujosEtapasCompuesta>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon id="Icono-Agregar"/>,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon id="Icono-Editar" color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IFlujosEtapasCompuesta),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon id="Icono-Refrescar"/>,
        onClick: cargarFlujosEtapas,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon id="Icono-Eliminar" color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IFlujosEtapasCompuesta),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IFlujosEtapasCompuesta> = {
    maxBodyHeight: '50vh',
};
